/**
 * 该文件主要用于店铺装修标签
 */

export const CASE_HOT_TAG = {
  '61': '店长推荐',
  '62': '流行风向标',
  '63': '匠心定制',
  '64': '性价比首选'
}

export const MEAL_TAG_IMG = {
  '1': '//qnm.hunliji.com/o_1dnsas1tg16r317fek8hi4quold.png',
  '2': '//qnm.hunliji.com/o_1dnsas1tf1j3280h1t4rbgh168mb.png',
  '3': '//qnm.hunliji.com/o_1dnsas1tgdhd15fq5nfiiitvgc.png'
}
